import { ApprovalDelegationEntity } from './approval-delegation.entity';

export class WorkloadTimeOffBlockEntity {
  public id!: string;
  public timeOffTypeId!: string;
  public timeOffTypeName!: string;
  public startDate!: string;
  public endDate!: string;
  public notes!: string | null;
  public approvalDelegations!: ApprovalDelegationEntity[];
}
